import * as types from '@/store/types'
export default {
    app_vk: state => {
        return state.app_vk
    },
    modelDefault: state => {
        return state.modelDefault
    },
    allowMessagesGroup: state => {
        return state.allowMessagesGroup
    },
    allowMessagesGroupError: state => {
        return state.allowMessagesGroupError
    },
    allowMessagesGroupList: state => {
        return state.allowMessagesGroupList
    },
    sign: state => {
        return state.sign
    },
    getMainMailingGroup: state => {
        return state.mailingGroups.find(mailingGroup => mailingGroup.main === 1)
    },
    getVisibleMailingGroups: state => {
        return state.mailingGroups.filter(mailingGroup => mailingGroup.visible_group === 1 || state.adminMode)
    },
    getSecretMailingGroupById: state => id => {
        return state.mailingGroups.find(mailingGroup => mailingGroup.id === id)
    },
    mailingGroupsLoaded: state => {
        return state.mailingGroupsLoaded
    },
    adminMode: state => {
        return state.adminMode
    },
    botId: state => {
        return state.botId
    },
    client: state => {
        return state.client
    }
}
